import { createFileRoute } from '@tanstack/react-router'
import { SuratTable } from '../../../../components/SuratTable'

export const Route = createFileRoute('/platform/desa/$desaId/surat')({
  component: () => {
    const { desaId } = Route.useParams()
    return <SuratTable desaId={desaId} />
  },
})
